import React, { useEffect } from "react";
import { setDangerousHtml } from "src/utils";
import { advertiseData, handleAuxClick  } from "../trackers/trackers";
import { fireImpressionEvent } from "../../../events";

const YahooAd = ({
  item,
  index,
  loading,
  sponsoredSearchResults2Style,
  extraParams,
  data,
  country,
  sendClientEvents,
  reqId,
  clickNotify,
  URL,
  articlePage
}) => {
  const { title, description, domain, clickUrl, children, dataK, appNs, impressionId, extension } = item;

  const auxClickHandler = handleAuxClick(clickNotify);

  useEffect(() => {
    let active = true;

    if (active) {
      if (!extraParams.dublicateResults) {
        if(index === 0) fireImpressionEvent('sponsoredSearchResults2', 0, ['fbclid','spx']);
        advertiseData(item || {}, data, extraParams, { URL, country, sponsoredSearchResults2Style, index: index + 1, reqId });
        sendClientEvents({ ...item, filled: "yes" }, "impression", index + 1);
      }
    }

    return () => {
      active = false;
    };
  }, []);

  const noTextCTA = ["CHEVRONCTA", "NUMBEREDCARDSLAYOUTCTA", "BASIC", "WEBSITEFIRST", "CARDSLAYOUT", "NUMBEREDCARDSLAYOUT"];
  const indexCTA = noTextCTA.indexOf(sponsoredSearchResults2Style);
  const overrideRuleCTA =
    sponsoredSearchResults2Style === "CARD_LAYOUT_WITH_CTA_TEXT" ||
    sponsoredSearchResults2Style === "SQAURED_CARD_LAYOUT_WITH_CTA" ||
    sponsoredSearchResults2Style === "NUMBEREDCARDSLAYOUTCTA" ||
    sponsoredSearchResults2Style === "WRAPPEDNUMBEREDCARD";

  return loading ? (
    <div>Loading....</div>
  ) : (
    <div
      key={index}
      className="adItem"
      data-yiid={impressionId || ""}
      data-appns={appNs}
      data-k={dataK}
      style={{ padding: extension?.text ? {} : "unset" }}
    >
      {sponsoredSearchResults2Style === "LEFTCTA" && extension?.text && (
        <CtaButton
          data={data}
          item={item}
          index={index}
          reqId={reqId}
          indexCTA={indexCTA}
          extension={extension}
          style={sponsoredSearchResults2Style}
          clickNotify={clickNotify(item, index + 1, data, {}, reqId)}
          auxClickHandler={auxClickHandler(item, index + 1, data, {}, reqId)}
        />
      )}
      <div
        id="adContents"
        className="adContents"
        style={{
          paddingRight: overrideRuleCTA || articlePage ? (extension?.text ? {} : "10px") : {},
          paddingBottom: overrideRuleCTA || articlePage ? (extension?.text ? {} : "15px") : {}
        }}
      >
        <div className="div_title">
          <a
            className="title skip-scroll-tracker"
            ref={setDangerousHtml(title)}
            href={clickUrl}
            onClick={clickNotify(item, index + 1, data, {}, reqId)}
            onAuxClick={auxClickHandler(item, index + 1, data, {}, reqId)}
          />
        </div>
        <div className="div_domain">
          <a
            className="domain skip-scroll-tracker"
            ref={setDangerousHtml(domain)}
            href={clickUrl}
            onClick={clickNotify(item, index + 1, data, {}, reqId)}
            onAuxClick={auxClickHandler(item, index + 1, data, {}, reqId)}
          />
        </div>
        <div className="descriptionContainer">
          <div className="div_description">
            <a
              className="description skip-scroll-tracker"
              ref={setDangerousHtml(description)}
              href={clickUrl}
              onClick={clickNotify(item, index + 1, data, {}, reqId)}
              onAuxClick={auxClickHandler(item, index + 1, data, {}, reqId)}
            />
          </div>
        </div>
        {sponsoredSearchResults2Style !== "LEFTCTA" && extension?.text && (
          <CtaButton
            data={data}
            item={item}
            index={index}
            reqId={reqId}
            indexCTA={indexCTA}
            extension={extension}
            style={sponsoredSearchResults2Style}
            clickNotify={clickNotify(item, index + 1, data, {}, reqId)}
            auxClickHandler={auxClickHandler(item, index + 1, data, {}, reqId)}
          />
        )}
        <div>{children}</div>
      </div>
    </div>
  );
};

const CtaButton = ({ indexCTA, extension, style, clickNotify, auxClickHandler }) => (
  <div className={style === "LEFTCTA" ? "CTA_button_left_container" : ""}>
    <a
      className="CTA_button skip-scroll-tracker"
      href={extension.link}
      onClick={clickNotify}
      onAuxClick={auxClickHandler}
      ref={indexCTA > -1 ? undefined : setDangerousHtml(extension.text)}
    />
  </div>
);

export default YahooAd;
